export default "__VITE_ASSET__4854353b__"